import { setInterceptorNavigate } from "@services/AuthService";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
var InterceptorInit = function () {
    var navigate = useNavigate();
    useEffect(function () {
        setInterceptorNavigate(navigate);
    }, [navigate]);
    return null; // doesn't render anything
};
export default InterceptorInit;
